import React from "react";
import { Outlet } from "react-router-dom";
import NavbarV1 from "./NavbarV1";

const DashboardLayout = () => (
	<div>
		<NavbarV1 />
		<main className="dashboard-content">
			<Outlet />
		</main>
	</div>
);

export default DashboardLayout;
